import React from 'react';
import { Layout, Card, Typography } from 'antd';
import { useAuth } from '../context/AuthContext';
import NavigationBar from '../components/NavigationBar';
import NightBanner from '../components/festive/NightBanner';
import { useFestive } from '../utils/festive';

const { Content } = Layout;
const { Title, Text } = Typography;

const Dashboard = () => {
  const { user } = useAuth();
  const festive = useFestive();
  const name = `${user?.firstName || user?.first_name || ''} ${user?.lastName || user?.last_name || ''}`.trim();

  return (
    <>
      <NavigationBar />
      <Layout style={{ minHeight: '100vh', background: '#f0f2f5' }}>
        <Content style={{ padding: '24px' }}>
          {/* Welcome Message: on the Christmas night scene in season, unless turned off */}
          {festive.on ? (
            <NightBanner>
              <h2>Welcome to the Portal</h2>
              <p className="night-banner__hello">Hello, {name}!</p>
              <p>Please use the navigation bar to access the different sections of the portal.</p>
              <button type="button" className="night-banner__off" onClick={() => festive.setOn(false)}>
                Turn off decorations
              </button>
            </NightBanner>
          ) : (
            <Card style={{ marginBottom: '24px', textAlign: 'center', background: 'rgba(255, 255, 255, 0.95)', position: 'relative', zIndex: 10 }}>
              <Title level={2}>Welcome to the Portal</Title>
              <Text>Hello, {name}!</Text>
              <br />
              <Text type="secondary">Please use the navigation bar to access the different sections of the portal.</Text>
            </Card>
          )}
        </Content>
      </Layout>
    </>
  );
};

export default Dashboard;
